import React from "react";
import PropTypes from "prop-types";

const ListenOrWatchLiveLinks = ({
  listenTabActive,
  watchTabActive,
  radioLinks,
  videoLinks,
}) => (
  <>
    {listenTabActive && radioLinks && radioLinks.length > 0 && (
      <ul className="page-tags-live">
        {(radioLinks[0].text !== "" || radioLinks[1].text !== "") && (
          <li>Meer:</li>
        )}
        {radioLinks.map((radioLink) => {
          const target = radioLink.external ? "_blank" : null;
          const rel = radioLink.external ? "noopener noreferrer" : null;

          return (
            <li>
              <a href={radioLink.url} target={target} rel={rel}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: radioLink.text,
                  }}
                />
              </a>
            </li>
          );
        })}
      </ul>
    )}
    {watchTabActive && videoLinks && videoLinks.length > 0 && (
      <ul className="page-tags-live">
        {(videoLinks[0].text !== "" || videoLinks[1].text !== "") && (
          <li>Meer:</li>
        )}
        {videoLinks.map((videoLink) => {
          const target = videoLink.external ? "_blank" : null;
          const rel = videoLink.external ? "noopener noreferrer" : null;

          return (
            <li>
              <a href={videoLink.url} target={target} rel={rel}>
                <span
                  dangerouslySetInnerHTML={{
                    __html: videoLink.text,
                  }}
                />
              </a>
            </li>
          );
        })}
      </ul>
    )}
  </>
);

ListenOrWatchLiveLinks.propTypes = {
  listenTabActive: PropTypes.bool.isRequired,
  watchTabActive: PropTypes.bool.isRequired,
  radioLinks: PropTypes.array,
  videoLinks: PropTypes.array,
};

ListenOrWatchLiveLinks.defaultProps = {
  radioLinks: [],
  videoLinks: [],
};

export default ListenOrWatchLiveLinks;
